function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import useStyle from "./Slide.style";
import { useCarousel } from "./CarouselContext";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { useSlide } from "../SlideContext/SlideContext";
import { getPanelId, getTabId } from "../hooks/useUniquePrefix";
var Slide = function(param) {
    var children = param.children, index = param.index;
    var ref = useCarousel(), _state = ref.state, cols = _state.cols, insetControls = _state.insetControls, testID = _state.testID, prefixId = _state.prefixId, hideDots = _state.hideDots;
    var distanceFromFullyVisible = useSlide().distanceFromFullyVisible;
    var isVisible = Math.abs(distanceFromFullyVisible) === 0;
    var wrapper = useStyle({
        cols: cols,
        insetControls: insetControls,
        isVisible: isVisible
    }).wrapper;
    var Element = hideDots ? 'li' : 'div';
    return _jsx(Element, _objectSpread({
        inert: !isVisible ? '' : null,
        "aria-hidden": !isVisible,
        role: hideDots ? '' : 'tabpanel',
        id: getPanelId(prefixId, "".concat(index)),
        "aria-labelledby": hideDots ? null : getTabId(prefixId, "".concat(index)),
        css: wrapper
    }, injectTestId(testID && "".concat(testID, ".slide.").concat(index)), {
        children: children
    }));
};
export default Slide;
